import { closeModal } from '../../modals/framework/store/modal-actions';
import { MODAL_TYPE_POST_SETTINGS } from '@wix/communities-blog-client-common/dist/src/constants/modal-types';

export const discardPostSettings = () => closeModal({ type: MODAL_TYPE_POST_SETTINGS });
